// extracted by mini-css-extract-plugin
export default {"table":"DataTableRemotePaging_table__JOIPh","pageSize":"DataTableRemotePaging_pageSize__u+q3i","selected":"DataTableRemotePaging_selected__cQFuh"};